import PropTypes from "prop-types";

const EditCell = ({ onChange, onBlur, value }) => {
	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			e.stopPropagation();
		}
	};

	return (
		<input
			data-testid="DS__data-table3-edit-input"
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			onKeyDown={handleKeyDown}
			className="custom-headers__create-input"
		/>
	);
};

EditCell.propTypes = {
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	value: PropTypes.any,
};

export default EditCell;
